import { Directive, OnInit, TemplateRef, ViewContainerRef, ElementRef, Input, HostBinding } from '@angular/core';
import { environment } from 'src/environments/environment';
import { EnvironmentApplication } from 'src/environments/models/environment-application';

@Directive({
  selector: '[appFlagApplication]'
})
export class FlagApplicationDirective implements OnInit {
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {

  }

  @Input()
  public get appFlagApplication() {
    return this._appFlagApplication;
  }
  public set appFlagApplication(value: EnvironmentApplication | EnvironmentApplication[]) {
    this._appFlagApplication = value;
  }
  private _appFlagApplication: EnvironmentApplication | EnvironmentApplication[];

  @Input()
  public get appFlagApplicationMode(): 'include' | 'exclude' {
    return this._appFlagApplicationMode;
  }
  public set appFlagApplicationMode(value: 'include' | 'exclude') {
    this._appFlagApplicationMode = value;
  }
  private _appFlagApplicationMode: 'include' | 'exclude' = 'include';


  ngOnInit() {
    this.update();
  }

  update() {
    // Determine if the current environment matches the flag
    let hasMatch = false;
    if (Array.isArray(this.appFlagApplication)) {
      hasMatch = this.appFlagApplication.some(application => application === environment.application);
    } else if (typeof this.appFlagApplication === 'string') {
      hasMatch = this.appFlagApplication === environment.application;
    }

    // Hide or show depending on exclusion mode
    const include = 
      (hasMatch && this.appFlagApplicationMode === 'include') ||
      !hasMatch && this.appFlagApplicationMode === 'exclude';

    if (include) {
      this.viewContainer.createEmbeddedView(this.templateRef);  
    } else {
      this.viewContainer.clear();
    }
  }
}
